/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useToast } from '@chakra-ui/react';
import axios from 'axios';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useLocalStorage } from '../hooks/useLocalStorage';
import { getDadosLogin } from '../utils/dados-login.util';

type UserAuthenticationProps = {
  username: string;
  password: string;
  token?: string;
};

type UserData = {
  name?: string;
  isAdvice?: boolean;
  isAuthenticated?: boolean;
};

export type AuthContextData = {
  login(data: UserAuthenticationProps, loginScreen?: boolean): Promise<void>;
  logout(): void;
  checkUser(): void;
  redirectUser(onOpen: () => void, path?: string): Promise<void>;
  user: UserData;
};

type AuthContextProviderProps = {
  children: ReactNode;
};

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
  const [searchParams] = useSearchParams();

  const [, setUserToken] = useLocalStorage('pdn:token', null);

  const [, setLocalStorageUser] = useLocalStorage('pdn:user', null);

  const [user, setUser] = useState<UserData>({});

  const [checkUserCalled, setCheckUserCalled] = useState(false);

  const navigate = useNavigate();

  const toast = useToast();

  useEffect(() => {
    const currentPage = localStorage.getItem('currentPage');
    const location = window.location.pathname;
    if (
      currentPage &&
      location != '/login' &&
      !location.includes('confirmacao-email')
    ) {
      navigate('login');
      navigate(0);
    }
    console.log('rodou aqui');
  }, [checkUserCalled]);

  const login = async (
    data: UserAuthenticationProps,
    loginScreen?: boolean
  ) => {
    try {
      const url = `${process.env.REACT_APP_SENSEDIA_OAUTH_API}/access-token`;
      const token = process.env.REACT_APP_SENSEDIA_CLIENT_ID;
      const params = new URLSearchParams({
        grant_type: 'password',
        username: data.username,
        password: data.password
      });
      const response = await axios.post(url, params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${token}`,
          'Access-Control-Allow-Origin': 'http://localhost:3000',
          'tipo-usuario': 'C'
        }
      });

      if (response.data.access_token) {
        localStorage.clear();
        data.token = response.data.access_token;

        const refreshToken = response.data.refresh_token;

        const expiresIn = response.data.expires_in;

        setUserToken(data.token);
        localStorage.setItem('tokenPortal', data.token || '');
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('expiresIn', expiresIn);
        localStorage.setItem('tokenCreatedAt', String(Date.now()));
        const path = localStorage.getItem('currentPage');
        if (loginScreen === true) {
          await redirectUser(() => {
            // console.log('Error')
          }, path!);
          return;
        }
        navigate('corretor');
        return;
      }
    } catch (error: any) {
      if (
        error?.response?.data?.data?.details?.includes('401') ||
        error?.response?.data?.result?.includes('401')
      ) {
        if (loginScreen === true) {
          throw error;
        } else {
          toast({
            position: 'top',
            description: 'Usuário e/ou Senha incorretos.',
            status: 'error',
            duration: 2000,
            isClosable: true
          });
          return;
        }
      }
      throw new Error();
    }
  };

  const logout = () => {
    setUserToken(null);
  };

  const checkUser = () => {
    const token = localStorage.getItem('tokenPortal');
    localStorage.removeItem('currentPage');
    if (!token || token === '') {
      const path = window.location.pathname;
      localStorage.setItem('currentPage', path);
      setCheckUserCalled(true);
    }
  };

  const redirectUser = async (onOpen: () => void, path?: string) => {
    try {
      const token = localStorage.getItem('tokenPortal');
      // const axiosConfig = {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //  }
      // };
      if (!token) return;

      const dadosLogin = await getDadosLogin({ newLogin: true });

      console.log(dadosLogin);
      setLocalStorageUser({
        user: {
          name: dadosLogin?.name,
          isManager: dadosLogin?.isManager,
          sellerWithElevateAccess: dadosLogin?.sellerWithElevateAccess,
          seller: dadosLogin?.seller
        }
      });
      setUser({
        name: dadosLogin.name,
        isAdvice: dadosLogin.isAdvice,
        isAuthenticated: true
      });
      // token && navigate('corretor');

      if (path) {
        navigate(path);
      } else if (dadosLogin.isAdvice) {
        token && navigate('assessoria');
      } else if (
        !dadosLogin?.sellerWithElevateAccess &&
        !dadosLogin?.isManager
      ) {
        navigate('/corretor/leads/kanban');
      } else if (
        dadosLogin?.sellerWithElevateAccess &&
        dadosLogin?.seller?.redirects_to?.path
      ) {
        navigate(dadosLogin?.seller?.redirects_to?.path);
      } else token && navigate('corretor');
    } catch (error: any) {
      // location.pathname === '/' && navigate('nao-autorizado');

      onOpen();

      throw new Error();
    }
  };

  const value = useMemo(
    () => ({
      login,
      logout,
      checkUser,
      redirectUser,
      user
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
